
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeBargeFilled as ObiVesselTypeBargeFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-barge-filled.js';
 
 
 

 
 export const ObiVesselTypeBargeFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-barge-filled',
   elementClass: ObiVesselTypeBargeFilledElement,
   events: {
     
   }
  });
 
 